import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { ItStakeholderHeroSection } from "@/components/insights/it-stakeholder/ItStakeholderHeroSection";
import { ItStakeholderTakeaway } from "@/components/insights/it-stakeholder/ItStakeholderTakeaway";
import { ItStakeholderFounderQuote } from "@/components/insights/it-stakeholder/ItStakeholderFounderQuote";
import { ItStakeholderRolesSection } from "@/components/insights/it-stakeholder/ItStakeholderRolesSection";
import { ItStakeholderRaciMatrix } from "@/components/insights/it-stakeholder/ItStakeholderRaciMatrix";
import { ItStakeholderCollaboration } from "@/components/insights/it-stakeholder/ItStakeholderCollaboration";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const ItStakeholderRoles = () => {
  return (
    <>
      <InsightSEO 
        slug="it-stakeholder-roles" 
        additionalKeywords={["IT stakeholders", "CTO role", "CIO responsibilities", "IT Director", "DevOps engineer", "technology leadership", "IT governance"]}
      />
      <InsightEngagementTracker slug="it-stakeholder-roles" title="IT Stakeholder Roles" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Business IT" 
          currentPage="IT Stakeholder Roles" 
        />
        <ItStakeholderHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <ItStakeholderTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <ItStakeholderFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <ItStakeholderRolesSection />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ItStakeholderRaciMatrix />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ItStakeholderCollaboration />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="it-stakeholder-roles" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="it-stakeholder-roles" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="it-stakeholder-roles" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default ItStakeholderRoles;
